import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { Radio } from '../../../../Forms';
export var RadioField = function RadioField(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onChange = _ref.onChange;
  var format = field.format;
  return React.createElement("div", null, format.map(function (item, index) {
    return React.createElement(Radio, {
      key: index,
      id: "checkbox-".concat(field.field, "-").concat(index),
      name: "checkbox-".concat(field.field, "-").concat(index),
      value: "checked",
      handleChange: function handleChange() {
        var newValue = ['number'].includes(field.type) ? Number(item.value) : item.value;
        onChange(newValue);
      },
      checked: value == item.value
    }, React.createElement("span", null, item.description));
  }));
};